module.exports = __webpack_public_path__ + "img/Weapon_234.be53631f.png";